import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Dropzone } from '@dropzone-ui/react';
import { delete_file, download_icon_small } from '../../../../utils/images';
import { shouldFetchData, status } from '../../../../data/fetchStatus';
import Services from '../../../Services/services';
import { ClientContext } from '../../../Contexts/contexts';
import { quoteStatus } from '../../../../data/quoteStatus';
import useToast from '../../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../../Toasts/ToastOptions/toastOptions';

function QuoteElementUserMissionModal(props) {
  const clientContext = useContext(ClientContext);
  const enqueueToast = useToast();

  const [showModal, setShowModal] = useState(false);

  // Fetch documentType data from database
  const [documentTypes, setDocumentTypes] = useState([]);
  const [documentTypesFetched, setDocumentTypesFetched] = useState(
    status.DEFAULT
  );

  //  useState pour la DropZone
  const [files, setFiles] = React.useState([]);

  const [selectedDocumentType, setSelectedDocumentType] = useState('');

  const fetchDocumentTypes = useCallback(async () => {
    if (documentTypesFetched === status.FETCHED) return;

    setDocumentTypesFetched(status.FETCHED);

    try {
      const documentTypesData = await Services.documentService.documentTypes();

      setDocumentTypes(documentTypesData);
    } catch (error) {
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }
  }, [documentTypesFetched, enqueueToast]);

  useEffect(() => {
    if (shouldFetchData(documentTypesFetched)) fetchDocumentTypes();
  }, [documentTypesFetched, fetchDocumentTypes]);

  function updateFiles(incommingFiles) {
    setFiles(incommingFiles);
  }

  // Pour supprimer un file uploaded
  function onDeleteItem() {
    setFiles([]);
  }

  function closeModal(e) {
    e.stopPropagation();
    setShowModal(false);
  }

  function onClickDocumentType(e) {
    setSelectedDocumentType(e.target.value);
  }

  async function validateModal() {
    if (!selectedDocumentType.length || files.length !== 1) return;

    let onError = false;

    try {
      const fileNames = files.map(
        (file) => `${Date.now()}_${file.name.replace(/\s/g, '')}`
      );

      const uploadLinks = await Services.documentService.generateUploadLinks(
        fileNames
      );

      for (const [idx, value] of files.entries()) {
        await Services.documentService.uploadFile(value.file, uploadLinks[idx]);
      }

      await Services.documentService.createDocumentUploaded(
        files[0].name,
        fileNames[0],
        selectedDocumentType,
        props?.clientExpertRelation?.clientId,
        props?.clientExpertRelation?.expertId,
        'client',
        'client mission letter'
      );

      let status = props?.clientExpertRelation?.status;

      if (status < quoteStatus.signed) {
        if (props?.clientExpertRelation?.expertSigned === -1)
          status = quoteStatus.investigation;
      }

      await Services.quoteService.updateClientExpertRelation(
        props?.clientExpertRelation?.id,
        {
          clientSigned: 1,
          status,
          statusDate: new Date().toISOString(),
        }
      );
    } catch (error) {
      onError = true;
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }

    if (onError) return;

    try {
      await Services.emailService.sendClientContractExpert(
        props?.clientExpertRelation?.expert?.userId,
        'CEC : Félicitation, vous avez contracté avec votre client',
        props?.clientExpertRelation?.expert?.firstName,
        props?.clientExpertRelation?.expert?.lastName
      );
    } catch (error) {
      console.error(error);
    }

    clientContext?.fetchAll();

    enqueueToast(ToastMessages.CONFIRM_SUCCESS_APPOINTMENT, {
      theme: ToastThemes.toastThemes.CONFIRM_SUCCESS,
      header: ToastHeaders[ToastThemes.toastThemes.CONFIRM_SUCCESS],
      duration: 3000,
    });
  }

  async function rejectPrestation() {
    try {
      let status = props?.clientExpertRelation?.status;

      // update the clientExpertRelation
      await Services.quoteService.updateClientExpertRelation(
        props?.clientExpertRelation?.id,
        {
          clientSigned: -1,
          status,
          statusDate: new Date().toISOString(),
        }
      );

      clientContext?.fetchAll();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <div className="signing-statut">
        <div className="did-you-sign">
          Avez-vous signé la validation de contrat avec l'expert comptable ?
        </div>
        <div className="container-signing-button">
          <span onClick={() => rejectPrestation()}>
            Prestation non effectuée
          </span>
          <div className="element-button" onClick={() => setShowModal(true)}>
            Contrat validé avec l'expert
          </div>
        </div>
      </div>
      {showModal && (
        <div className="container-rdv-modal">
          <div
            className="background-rdv-modal"
            onClick={(e) => closeModal(e)}
          ></div>
          <div className="modal-dropfile">
            <div className="modal-dropfile-title">
              Importer des document à l'expert
            </div>
            <Dropzone
              color="#4188F2"
              onChange={(files) => updateFiles(files)}
              maxFiles={1}
              header={false}
              footer={false}
              style={{
                fontFamily: 'Poppins regular',
                fontSize: '14px',
                textDecoration: 'underline',
                border: 'none',
                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='%234188F2FF' stroke-width='2' stroke-dasharray='14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
              }}
            >
              <div className="container-img-label">
                <img src={download_icon_small} alt="downlad icon small"></img>
                <div>Importer contrat ou lettre de mission signée</div>
              </div>
            </Dropzone>
            <div className="modal-files-details">
              <label htmlFor="type-files" className="modal-type-files-title">
                Type de document fourni
              </label>

              <select
                name="files"
                id="files-select"
                className="modal-input"
                onChange={(e) => onClickDocumentType(e)}
              >
                <option value={''}>--Veuillez choisir--</option>
                {documentTypes.map((docType) => (
                  <option value={docType.id} key={docType.id}>
                    {docType.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="modal-file-list">
              {files.length > 0 && (
                <div className="modal-file-item">
                  <span className="modal-item-name">{files[0].name}</span>
                  <img
                    src={delete_file}
                    className="modal-item-icon"
                    alt="delete file icon"
                    onClick={() => onDeleteItem()}
                  />
                </div>
              )}
            </div>
            <div className="choose-file" onClick={() => validateModal()}>
              Confirmer
            </div>
            <div
              className="cancel-file-modal"
              onClick={() => setShowModal(false)}
            >
              Annuler
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default QuoteElementUserMissionModal;
